// Achievement Image Registry for portal-frontend.
// Mirrors game-client/src/assets/achievements/achievement-images.ts — keep in sync.
// To add a new badge: add the PNG to this folder (same filename as in game-client) and add an entry here.
import teamworkExcellenceImg from './teamwork-excellence.png';

const achievementImages: Record<string, string> = {
  'teamwork-excellence': teamworkExcellenceImg,
};

export function getAchievementImage(imageId: string): string | undefined {
  return achievementImages[imageId];
}
